// extracted by mini-css-extract-plugin
export default {"description":"ContentDescription_description__ItJ5j"};